import Select, { SelectOption } from '@components/select';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { FavoritesPagination } from 'components/FavoritesPagination';
import { Field } from 'components/Field';
import { useStore } from 'hooks/useStore';
import { PrettyLoad } from 'layout/Search/PrettyLoad';
import { tabIds } from 'store/UIStore/UIStore';

import css from './Content.module.css';

const Content = () => {
  const {
    app: { i18n },
    view,
    favorites,
    ui: { activeTab },
  } = useStore();

  const handleItemsPerPageChange = (option: SelectOption) => {
    const newPage = Math.ceil(((favorites.page - 1) * favorites.itemsPerPage.data + 1) / option.value);
    favorites.setPage(newPage);
    favorites.itemsPerPage.setOption(option);
    favorites.updateLoads();
  };

  if (activeTab !== tabIds.favorites || favorites.count === 0) return null;

  return (
    <div>
      <div className={css.heading}>
        <h2 className={cn(css.totalItems, 'glz-h glz-is-size-2')}>{view.pluralizedCount(favorites.count, 'loads')}</h2>

        {favorites.totalPages > 1 && <FavoritesPagination className={css.pagination} />}
      </div>

      <div className={cn(css.actions, css.actions_top)}>
        <Field isRow labelClassName={css.sortLabel} labelText={i18n.app.showLines}>
          <Select
            className={css.sortSelect}
            isSearchable={false}
            options={favorites.itemsPerPage.options}
            value={favorites.itemsPerPage.option}
            onChange={handleItemsPerPageChange}
          />
        </Field>
      </div>

      <PrettyLoad
        callbacks={{
          hideLoads: () => {},
          onRemoveLoadFromFavorites: favorites.handleRemoveLoadFromFavorites,
          selectLoads: favorites.selectedLoads.toggleSelection,
          onFavoritesFAQPopoverClose: favorites.handleFavoritesFAQPopoverClose,
        }}
        currentPage={favorites.page}
        descriptor={{ isFavorites: true }}
        loads={favorites.checkedLoads}
      />

      {favorites.totalPages > 1 && (
        <div className={cn(css.actions, css.actions_bottom)}>
          <FavoritesPagination className={css.pagination} />

          <Field containerClassName={css.sortField} labelClassName={css.sortLabel} labelText={i18n.app.showLines}>
            <Select
              className={css.sortSelect}
              isSearchable={false}
              options={favorites.itemsPerPage.options}
              value={favorites.itemsPerPage.option}
              onChange={handleItemsPerPageChange}
            />
          </Field>
        </div>
      )}
    </div>
  );
};

const connected = observer(Content);

export { connected as Content };
